module.exports = __webpack_public_path__ + "img/5.948f70d0.svg";